<script lang="ts">
  let {
    label,
    id,
    checked = $bindable(false),
  }: {
    label: string;
    id: string;
    checked?: boolean;
  } = $props();
</script>

<label for={id} class="flex cursor-pointer items-center gap-6">
  <input type="checkbox" {id} class="checkbox" bind:checked />
  <span class="checkbox-label font-medium">{@html label}</span>
</label>

<style>
  @reference '$src/css/main.css';

  .checkbox {
    @apply relative z-2 box-border size-10 shrink-0 cursor-pointer appearance-none rounded-full border border-white/50 bg-center bg-no-repeat p-0 text-base transition-all duration-300 outline-none;

    &:focus-visible,
    &:not(:disabled):hover {
      @apply border-white;
    }

    &:checked {
      @apply border-white;
      background-size: 50% 50%;
      background-image: url("data:image/svg+xml;utf8,<svg width='17' height='13' viewBox='0 0 17 13' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M6.375 9.9412L15.5833 0L17 1.52941L6.375 13L0 6.11769L1.41667 4.58829L6.375 9.9412Z' fill='%23FFE100'/></svg>");
    }
  }

  :global(.checkbox-label a) {
    @apply underline hover:no-underline;
  }
</style>
